import { TransactionReceipt } from 'viem'
import { waitForTransactionReceipt } from '@wagmi/core'
import { config } from '../wagmi/config'

export const getTransactionReceipt = async (hash: `0x${string}`) => {
  return (await waitForTransactionReceipt(config, {
    hash: hash,
  })) as TransactionReceipt
}
